import store from '@/store/index';

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/');
      }
    }

    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  return format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    return value.toString().padStart(2, '0');
  });
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (`${time}`.length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return `${Math.ceil(diff / 60)}分钟前`;
  } else if (diff < 3600 * 24) {
    return `${Math.ceil(diff / 3600)}小时前`;
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return `${d.getMonth() + 1}月${d.getDate()}日${d.getHours()}时${d.getMinutes()}分`;
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  const search = url.substring(url.lastIndexOf('?') + 1);
  const obj = {};
  const reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, (rs, $1, $2) => {
    const name = decodeURIComponent($1);
    let val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
export function byteLength(str) {
  // returns the byte length of an utf8 string
  let s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    const code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;
    else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xdc00 && code <= 0xdfff) i--;
  }
  return s;
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
  const newArray = [];
  for (let i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
  if (!json) return '';
  return cleanArray(
    Object.keys(json).map(key => {
      if (json[key] === undefined) return '';
      return `${encodeURIComponent(key)}=${encodeURIComponent(json[key])}`;
    }),
  ).join('&');
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ');
  if (!search) {
    return {};
  }
  const obj = {};
  const searchArr = search.split('&');
  searchArr.forEach(v => {
    const index = v.indexOf('=');
    if (index !== -1) {
      const name = v.substring(0, index);
      const val = v.substring(index + 1, v.length);
      obj[name] = val;
    }
  });
  return obj;
}

/**
 * @param {string} val
 * @returns {string}
 */
export function html2Text(val) {
  const div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
export function objectMerge(target, source) {
  if (typeof target !== 'object') {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  Object.keys(source).forEach(property => {
    const sourceProperty = source[property];
    if (typeof sourceProperty === 'object') {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
export function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  let classString = element.className;
  const nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += `${className}`;
  } else {
    classString =
      classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

/**
 * @param {string} type
 * @returns {Date}
 */
export function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function (...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone(source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone');
  }
  const targetObj = source.constructor === Array ? [] : {};
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
export function uniqueArr(arr) {
  return Array.from(new Set(arr));
}

/**
 * @returns {string}
 */
export function createUniqueString() {
  const timestamp = `${+new Date()}`;
  const randomNum = `${parseInt((1 + Math.random()) * 65536)}`;
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp(`(\\s|^)${cls}(\\s|$)`));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ` ${cls}`;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp(`(\\s|^)${cls}(\\s|$)`);
    ele.className = ele.className.replace(reg, ' ');
  }
}

/*
 * @authr kim
 * @des 为了解决 列表搜索太多项 ， 需要设置 计算属性 其中包含大量的重复代码 的问题， 封装一个公共的方法
 * @param [ Array ] { searchList } 搜索的vuale值  有多少个存放到数组多少个 [id,name]
 * @param [ String ] { vuexModelName } 当前组件的vueModoleName
 * @return [ Object] 返回一个对象 对象计算属性的 get set 方法集合 ， 直接放到 computed下 就可以了
 */

export function searchParamsComputed(searchList = [], vuexModelName = '') {
  const computed = {};
  searchList.forEach(item => {
    computed[item] = {
      get() {
        return store.state[vuexModelName].postParams[item];
      },
      set(val) {
        store.commit(`${vuexModelName}/updatePostParams`, {
          [item]: val,
        });
      },
    };
  });
  return computed;
}

// 只能输入maxlen位整数 默认五位 并且小数点后面+俩0
export function money(input, maxlen = 5) {
  input = input.replace(/[^\d.]/g, '');
  if (input.indexOf('.') === -1 && input.charAt(maxlen) !== '.') return input.substr(0, maxlen);
  return input.replace(/(\d*)(\.\d{0,2})?.*/, (match, p1, p2) => {
    return Number(p1) + (p2 || '');
  });
}

/**转化金额**/
export function convert(money) {
  if (!money) return '00.00';
  var s = money;
  /**获取小数型数据**/
  s += '';
  if (s.indexOf('.') == -1) s += '.0'; /**如果没有小数点，在后面补个小数点和0**/
  if (/\.\d$/.test(s)) s += '0'; /**正则判断**/
  while (/\d{4}(\.|,)/.test(s) /**符合条件则进行替换**/)
    s = s.replace(/(\d)(\d{3}(\.|,))/, '$1,$2'); /**每隔3位添加一个**/
  return s;
}

// input框输入金额保存小数点后两位
export function oninput(tmpVal) {
  if (tmpVal) {
    tmpVal = tmpVal && tmpVal.replace(/[^\d\.]/g, '');
    const reg = /^(0|([1-9]\d*))(\.\d{1,2})?$/; //正则验证保留 最多允许后输入两位小数
    if (!reg.test(tmpVal)) {
      tmpVal = `${tmpVal}`;
      tmpVal = tmpVal.substring(0, tmpVal.indexOf('.') + 3);
      var n = tmpVal.split('.').length - 1;
      if (n > 1) {
        tmpVal = tmpVal.substring(0, tmpVal.indexOf('.'));
      }
    }
    return tmpVal;
  } else {
    return '';
  }
}

//转换图片地址、
export function changeImg(img) {
  if (!img) {
    return;
  }
  if (img.indexOf('rest') < 0) {
    return img;
  }
  return process.env.VUE_APP_BASIC_IMG + img.replace(/\/rest\/image/g, '');
}

/**
 * @param {Function} func
 * @param {number} wait
 * @return {*}
 */
export function debounce2(func, wait) {
  let timeout, args, context, timestamp, result;

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function (...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}

/**
 * @description: 将store state computed 化
 * @param {array} list
 * @param {string} vuexModelName
 * @return {object} computed
 * @author: lijinpeng
 */
export function storeStateComputed(list = [], vuexModelName = '') {
  const computed = {};
  list.forEach(item => {
    computed[item] = {
      get() {
        return store.state[vuexModelName][item];
      },
      set(value) {
        store.commit(`${vuexModelName}/updateState`, {
          key: item,
          value,
        });
      },
    };
  });
  return computed;
}

export function onlyNumOnePoint(number_only) {
  if (number_only) {
    //先把非数字的都替换掉，除了数字和小数点
    number_only = number_only.replace(/[^\d.]/g, '');
    //必须保证第一个为数字而不是小数点
    number_only = number_only.replace(/^\./g, '');
    //保证只有出现一个小数点而没有多个小数点
    number_only = number_only.replace(/\.{2,}/g, '.');
    //保证小数点只出现一次，而不能出现两次以上
    number_only = number_only.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
    //保证只能输入两个小数
    number_only = number_only.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
    return number_only;
  } else {
    return '';
  }
}

// 时间戳转时间
export function stampTurnsTime(time) {
  const date = new Date(time);
  const Y = `${date.getFullYear()}-`;
  const M = `${date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1}-`;
  let D = `${date.getDate()} `;
  const h = date.getHours() < 10 ? `0${date.getHours()}:` : `${date.getHours()}:`;
  const m = `${date.getMinutes()}:`;
  const s = date.getSeconds();
  D = D.length === 2 ? `0${D}` : D;
  const mm = m.length === 2 ? `0${m}` : m;
  const ss = s.length === 2 ? `0${s}` : s;
  return Y + M + D + h + mm + ss;
}

export function smallToBig(money) {
  //  将数字金额转换为大写金额
  const cnNums = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']; //汉字的数字
  const cnIntRadice = ['', '拾', '佰', '仟']; //基本单位
  const cnIntUnits = ['', '万', '亿', '兆']; //对应整数部分扩展单位
  const cnDecUnits = ['角', '分', '毫', '厘']; //对应小数部分单位
  const cnInteger = '整'; //整数金额时后面跟的字符
  const cnIntLast = '元'; //整数完以后的单位
  //最大处理的数字
  const maxNum = 999999999999999.9999;
  let integerNum = 0; //金额整数部分
  let decimalNum = 0; //金额小数部分
  //输出的中文金额字符串
  let chineseStr = '';
  // var parts; //分离金额后用的数组，预定义
  if (money == '') {
    return '';
  }

  money = parseFloat(money);
  if (money >= maxNum) {
    //超出最大处理数字
    return '超出最大处理数字';
  }
  if (money == 0) {
    chineseStr = cnNums[0] + cnIntLast + cnInteger;
    return chineseStr;
  }

  //四舍五入保留两位小数,转换为字符串
  money = Math.round(money * 100).toString();
  integerNum = money.substr(0, money.length - 2);
  decimalNum = money.substr(money.length - 2);

  //获取整型部分转换
  if (parseInt(integerNum, 10) > 0) {
    let zeroCount = 0;
    const IntLen = integerNum.length;
    for (let i = 0; i < IntLen; i++) {
      const n = integerNum.substr(i, 1);
      const p = IntLen - i - 1;
      const q = p / 4;
      const m = p % 4;
      if (n == '0') {
        zeroCount++;
      } else {
        if (zeroCount > 0) {
          chineseStr += cnNums[0];
        }
        //归零
        zeroCount = 0;
        chineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
      }
      if (m == 0 && zeroCount < 4) {
        chineseStr += cnIntUnits[q];
      }
    }
    chineseStr += cnIntLast;
  }
  //小数部分
  if (decimalNum != '') {
    var decLen = decimalNum.length;
    for (var i = 0; i < decLen; i++) {
      var n = decimalNum.substr(i, 1);
      if (n != '0') {
        chineseStr += cnNums[Number(n)] + cnDecUnits[i];
      }
    }
  }
  if (chineseStr == '') {
    chineseStr += cnNums[0] + cnIntLast + cnInteger;
  } else if (decimalNum == '' || /^0*$/.test(decimalNum)) {
    chineseStr += cnInteger;
  }
  return chineseStr;
}

/**
 *
 * @des 数字格式化为金额格式 （3位一个逗号隔开）
 * @param { String } [ s ] 金钱格式字符串
 * @returns 222,22.00
 */

export function fomatNumMoney(s) {
  if (typeof s !== 'string') {
    s = String(s);
  }
  return s.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
}

/**
 * @description: 金额处理
 * @param {*} s
 * @return {*}
 * @author: lijinpeng
 */
export function formatMoneyConvert({ money, abs, thousandth = true, decimaLen = 2 }) {
  if (abs) {
    // 是否取绝对值
    money = Math.abs(money);
  }
  if (decimaLen) {
    // 保留几位小数
    money = (money / Math.pow(10, 2)).toFixed(decimaLen);
  }
  if (thousandth) {
    // 是否千分位化
    money = fomatNumMoney(money);
  }
  return money;
}

export function spliceURLParam(url, params) {
  function spliceURL(url, key, value) {
    url += url.indexOf('?') === -1 ? '?' : '&'; //判断url中是否有'?'
    url += `${encodeURIComponent(key)}=${encodeURIComponent(value)}`; //拼接
    return url;
  }

  for (const key in params) {
    if (params[key] || params[key] === 0) {
      url = spliceURL(url, key, params[key]);
    }
  }
  return url;
}

/**
 * @description: 获取相关白名单配置
 * @param {*} businessId 企业ID
 * @param {*} channelInfoId 网货ID
 * @param {*} configItem 配置项
 * @return {Boolean} 是否配置
 * @author: lijinpeng
 */
export const getRiskConfig = (businessId, channelInfoId, configItem) => {
  const { enterpriseRiskConfig } = store.state;
  if (!enterpriseRiskConfig[businessId]) return false;
  if (!enterpriseRiskConfig[businessId][channelInfoId]) return false;
  const enterpriseChannelRiskConfig = enterpriseRiskConfig[businessId][channelInfoId];
  return enterpriseChannelRiskConfig.find(risk => risk.riskName === configItem) || false;
};

/**
 * @description: 地址转换处理
 * @param {*} businessId 企业ID
 */
export const getFullAddress = ({ province, city, district, address }) => {
  let addressNew = '';
  if (province && city && district) {
    addressNew = province === city ? `${city}${district}` : `${province}${city}${district}`;
    addressNew = address.includes(addressNew) ? address : `${addressNew}${address}`;
  }
  return addressNew;
};
